import { render } from "./svg-arrow.vue?vue&type=template&id=654f504e"
import script from "./svg-arrow.vue?vue&type=script&lang=ts"
export * from "./svg-arrow.vue?vue&type=script&lang=ts"
script.render = render

export default script